import React, { useEffect, useState } from "react";

import { Icon } from "@chakra-ui/react";
import { MdPerson } from "react-icons/md";
import { TbReceiptTax } from "react-icons/tb";
import { HiOutlineShoppingBag, HiReceiptTax } from "react-icons/hi";
import { AiFillBank, AiOutlineDashboard } from "react-icons/ai";
import { BiCategoryAlt, BiWallet } from "react-icons/bi";
import { TfiReceipt } from "react-icons/tfi";

// Admin Imports
import MainDashboard from "views/admin/default";

import EmbrillTds from "views/admin/EmbrillTds";
import EmbrillDirectTax from "views/admin/EmbrillDirectTax";
import Users from "views/admin/Users";
import AllCategory from "views/admin/AllCategory";
import EmbrillGst from "views/admin/EmbrillGst";
import EmbrillClientProjects from "views/admin/ClientProject/EmbrillClientProjets";
import {
  FaBriefcase,
  FaCameraRetro,
  FaLaptop,
  FaMoneyBill,
  FaUserCircle,
} from "react-icons/fa";
import EmbrillVendor from "views/admin/EmbrillVendor";
import VendorDetails from "views/admin/vendorDetail/VendorDetails";
import LegacyList from "views/admin/EmbrillLegacyList";
import OrgnizationProfile from "views/admin/OrgnizationProfile/orgnizationProfile";
import PurchaseItem from "views/admin/purchaseItem/purchaseItem";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetOrganizationModuleType } from "redux/organizationModuleSlice";
import OrganizationExpenseModule from "views/admin/OrgnizationExpenseModule/OrganizatonExpenseModule";
import {
  BsDoorOpen,
  BsFillBagPlusFill,
  BsFillHouseHeartFill,
} from "react-icons/bs";
import { GrResources } from "react-icons/gr";
import ProjectDetails from "views/admin/ClientProject/clientProjectDetail/ProjectDetails";
import OrganizationBank from "views/admin/OrganizationBank/OrganizationBank";
import { getSeletedIcon } from "components/allForm/OrgnizationProfile/expenseModule/moduleIcon";
import { fetchAsyncGetSalesInvoiceModule } from "redux/salesInvoiceModuleSlice";
import SalesInvoiceModule from "views/admin/SalesInvoiceModule/salesInvoiceModule";
import SalesItemModule from "views/admin/SalesItemModule/salesItemModule";
import { IoBagAddOutline } from "react-icons/io5";
import { getSeletedSalesModuleIcon } from "components/allForm/OrgnizationProfile/expenseModule/moduleIcon";
import InvoiceGstRecords from "views/admin/InvoiceRecords/InvoiceGstRecords";
import InvoiceTdsRecords from "views/admin/InvoiceRecords/InvoiceTdsRecords";
import InvoicePaymentRecords from "views/admin/InvoiceRecords/InvoicePaymentRecords";

const Access = {
  all: ["Admin", "Manager", "Accountant"],
  admin: ["Admin"],
  manager: ["Manager"],
};
const DashboardRoute = {
  name: "Main Dashboard",
  module: "Main Dashboard",
  layout: "/",
  path: "/dashboard",
  icon: (
    <Icon as={AiOutlineDashboard} width="20px" height="20px" color="inherit" />
  ),
  access: Access.all,
  place: "top",
  component: <MainDashboard />,
};
const StaticRoutes = [
  {
    name: "All Category",
    layout: "/",
    module: "All Category",
    path: "/all-category",
    icon: (
      <Icon as={BiCategoryAlt} width="20px" height="20px" color="inherit" />
    ),
    access: Access.all,
    place: "top",
    component: <AllCategory />,
  },
  {
    name: "Tax",
    layout: "/",
    icon: <Icon as={TbReceiptTax} width="20px" height="20px" color="inherit" />,
    path: "/tax",
    access: Access.all,
    place: "top",
    subRoutes: [
      {
        name: "TDS",
        module: "Tax Deducted at Source (TDS)",

        layout: "/",
        path: "/tds",
        icon: (
          <Icon as={TbReceiptTax} width="20px" height="20px" color="inherit" />
        ),
        access: Access.all,
        place: "top",
        component: <EmbrillTds />,
      },
      {
        name: "Direct Tax",
        module: "Direct Tax",

        layout: "/",
        icon: (
          <Icon as={HiReceiptTax} width="20px" height="20px" color="inherit" />
        ),
        path: "/direct-tax",
        access: Access.all,
        place: "top",
        component: <EmbrillDirectTax />,
      },
      {
        name: "GST",
        module: "Goods and Services Tax (GST)",
        layout: "/",
        icon: (
          <Icon as={TfiReceipt} width="20px" height="20px" color="inherit" />
        ),
        path: "/gst",
        access: Access.all,
        place: "top",
        component: <EmbrillGst />,
      },
    ],
  },

  {
    name: "Client & Projects",
    module: "Client and Projects",
    layout: "/",
    icon: <Icon as={FaUserCircle} width="18px" height="18px" color="inherit" />,
    path: "/client-project",
    access: Access.all,
    place: "bottom",
    component: <EmbrillClientProjects />,
  },
  {
    name: "Vendors",
    module: "Vendor",
    layout: "/",
    icon: <Icon as={FaBriefcase} width="17px" height="17px" color="inherit" />,
    path: "/vendor",
    access: Access.all,
    place: "bottom",
    component: <EmbrillVendor />,
  },

  {
    name: "Organization Profile",
    module: "Organization Profile",
    layout: "/",
    icon: <Icon as={FaLaptop} width="18px" height="18px" color="inherit" />,
    path: "/organization-profile",
    access: Access.all,
    place: "bottom",
    component: <OrgnizationProfile />,
  },
  {
    name: "Organization Bank",
    module: "Organization Bank",
    layout: "/",
    icon: <Icon as={AiFillBank} width="18px" height="18px" color="inherit" />,
    path: "/organization-bank",
    access: Access.all,
    place: "bottom",
    component: <OrganizationBank />,
  },

  {
    name: "Legacy List",
    module: "Legacy List",
    layout: "/",
    path: "/legacy",
    icon: (
      <Icon as={FaCameraRetro} width="16px" height="16px" color="inherit" />
    ),
    access: ["Admin"],
    place: "bottom",
    component: <LegacyList />,
  },
  {
    name: "Users",
    module: "Users",
    layout: "/",
    path: "/users",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    access: Access.admin,
    place: "bottom",
    component: <Users />,
  },
  {
    name: "Vendor Details",
    layout: "/",
    module: "Vendor Details",
    path: "/vendor/:id",
    icon: (
      <Icon as={BiCategoryAlt} width="20px" height="20px" color="inherit" />
    ),
    access: Access.all,
    place: "top",
    component: <VendorDetails />,
  },
  {
    name: "Project Details",
    layout: "/",
    module: "Project Details",
    path: "/client-project/:id",
    icon: (
      <Icon as={BiCategoryAlt} width="20px" height="20px" color="inherit" />
    ),
    access: Access.all,
    place: "top",
    component: <ProjectDetails />,
  },
];

const getIcon = {
  External: BsDoorOpen,
  Internal: BsFillHouseHeartFill,
  Resource: GrResources,
  SalesInvoice: BiWallet,
};
const useRoutes = () => {
  const [expenseRoutes, setExpenseRoutes] = useState([]);
  const [salesRoutes, setSalesRoutes] = useState([]);

  const dispatch = useDispatch();
  const moduleType = useSelector((state) => state.moduleType);
  const salesModule = useSelector((state) => state.salesModule);

  useEffect(() => {
    dispatch(fetchAsyncGetOrganizationModuleType());
    dispatch(fetchAsyncGetSalesInvoiceModule());
  }, [dispatch]);

  useEffect(() => {
    const routesFromModuleType =
      moduleType && moduleType.length
        ? moduleType.map((item) => ({
            name: item.name,
            module: item.name,
            layout: "/",
            path: `/${item.pth}/${item._id}`,
            icon:
              item?.icnImg && getSeletedIcon(item.icnImg) ? (
                getSeletedIcon(item.icnImg)
              ) : (
                <Icon
                  as={getIcon[item.typ]}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
            access: Access.all,
            place: "top",
            component: <OrganizationExpenseModule />,
          }))
        : [];

    setExpenseRoutes([...routesFromModuleType]);
  }, [moduleType]);

  useEffect(() => {
    const routesFromSalesModule =
      salesModule && salesModule.length
        ? salesModule.map((item) => ({
            name: item.name,
            module: item.name,
            layout: "/",
            path: `/${item.pth}/${item._id}`,
            icon:
              item?.icnImg && getSeletedSalesModuleIcon(item.icnImg) ? (
                getSeletedSalesModuleIcon(item.icnImg)
              ) : (
                <Icon
                  as={getIcon[item.typ]}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
            access: Access.all,
            place: "top",
            component: <SalesInvoiceModule />,
          }))
        : [];

    setSalesRoutes([
      ...routesFromSalesModule,
      {
        name: "Payment Received",
        module: "Payment Received",
        layout: "/",
        icon: (
          <Icon as={FaMoneyBill} width="20px" height="20px" color="inherit" />
        ),
        path: "/payment-received",
        access: Access.all,
        place: "top",
        component: <InvoicePaymentRecords />,
      },
      {
        name: "Invoice GST",
        module: "Invoice GST",
        layout: "/",
        icon: (
          <Icon as={TfiReceipt} width="20px" height="20px" color="inherit" />
        ),
        path: "/invoice-gst",
        access: Access.all,
        place: "top",
        component: <InvoiceGstRecords />,
      },
      {
        name: "Invoice TDS",
        module: "Invoice TDS",
        layout: "/",
        icon: (
          <Icon as={TbReceiptTax} width="20px" height="20px" color="inherit" />
        ),
        path: "/invoice-tds",
        access: Access.all,
        place: "top",
        component: <InvoiceTdsRecords />,
      },
    ]);
  }, [salesModule]);

  // Combine static and dynamic routes
  const routes = [
    DashboardRoute,
    {
      name: "Expenses",
      layout: "/",
      icon: <Icon as={BsDoorOpen} width="20px" height="20px" color="inherit" />,
      path: "/expenses",
      access: Access.all,
      place: "top",
      subRoutes: expenseRoutes,
    },
    ...StaticRoutes,
    {
      name: "Invoices",
      layout: "/",
      icon: <Icon as={BiWallet} width="20px" height="20px" color="inherit" />,
      path: "/invoices",
      access: Access.all,
      place: "top",
      subRoutes: salesRoutes,
    },
    {
      name: "Items",
      layout: "/",
      icon: (
        <Icon
          as={HiOutlineShoppingBag}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      path: "/items",
      access: Access.all,
      place: "top",
      subRoutes: [
        {
          name: "Purchase Items",
          module: "Purchase Items",
          layout: "/",
          icon: (
            <Icon
              as={IoBagAddOutline}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: "/purchase-items",
          access: Access.all,
          place: "top",
          component: <PurchaseItem />,
        },
        {
          name: "Sales Items",
          module: "Sales Items",
          layout: "/",
          icon: (
            <Icon
              as={BsFillBagPlusFill}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          path: "/sales-items",
          access: Access.all,
          place: "top",
          component: <SalesItemModule />,
        },
      ],
    },
  ];

  return routes;
};

export default useRoutes;
// export default routes;
